module.exports = "/assets/5c1bf294d35ecd57c880109084a642bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/SE.png
// module id = 2939
// module chunks = 0